import { setupOlark } from './olark'
import { setupFullstory } from './fullstory'
import { initGa4 } from './ga'

export { initAuthenticatedTracking, initUnauthenticatedTracking }

/* eslint-disable camelcase */
function initAuthenticatedTracking({
  user,
  toolkit_account,
  license,
  domains,
  schools,
  enable_fullstory
}: { user: { name: string, email: string }, toolkit_account: object, license: object, domains: { name: string }[], schools: object[], enable_fullstory: boolean }) {
  console.info('Initializing authenticated tracking')
  setupOlark(user.name, user.email)
  if (enable_fullstory) {
    setupFullstory(user, domains, schools, toolkit_account, license)
  }

  // only set initialize google analytics if not a goalbook person
  if (
    !domains ||
    domains.length === 0 ||
    (domains.length > 0 && ['goalbookapp.com', 'Goalbook Business'].indexOf(domains[0].name) < 0)
  ) {
    // Google Analytics 4
    initGa4(import.meta.env.VITE_APP_GA4_TOKEN)
  }
}

function initUnauthenticatedTracking({ enable_fullstory }: { enable_fullstory: boolean }) {
  console.info('Initializing unauthenticated tracking')
  if (enable_fullstory) {
    setupFullstory()
  }
  // Google Analytics 4
  initGa4(import.meta.env.VITE_APP_GA4_TOKEN)
}
